/* eslint-disable max-lines */
/* eslint-disable xss/no-mixed-html */
/* eslint-disable max-statements*/
/* eslint-disable no-negated-condition*/
/* eslint-disable complexity*/
/* eslint-disable id-length*/
ACC.neworder = {
  hiddenClass: 'hidden',
  upArrowCls: 'ph-icon-arrow-up',
  downArrowCls: 'ph-icon-arrow-down',
  detailsBarCls: 'ph-detailbar',
  orderPanelCls: 'orderPanel',
  advancedSearchCls: 'ph-advsearch-container',
  noordernewresult: '.ph-noordernewresult',
  orderdetailbar: 'ph-orderdetailbar',
  activeCls: 'ph-ordpanel-active',
  tabindex: 'tabindex',
  advSearchLoader: 'ph-advsearch-loader',
  pointerEventsAttr: 'pointer-events',
  ordetailsOverview: 'ph-orderdetails_overview',
  monthTabCls: 'ph-wholemonthorder',
  advSearchLink: 'ph-advsearch-links',
  paddingZero: 'ph-p-0',
  label12NC: 'ph-label-12NC',
  labelCtv: 'ph-label-CTV',
  labelEan: 'ph-label-EAN',
  canOrderid: 'data-canorderid',
  orderHistoryPanelCls: '.ph-orderhistory_panel',
  activePanelCls: 'ph-panel-active',
  orderfoldoutloader: 'orderhistory-loader',
  orderfoldbar: 'orderdetailbar',
  overlayCls: '.ph-overlay',
  formErrorCls: '.ph-formerrormsg',
  returnSubmitBtn: '.ph-returnordersubmitbutton',
  disabledBtnCls: 'ph-disable-button',
  fileListArray: [],
  uploadFileNameId: 'ph-upload-filename',
  commentInputId: '#ph-addreturncomments',
  formErrorLabel: 'ph-formerrormsg',
  fileListObject: [],
  uploadedAttachement: [],
  attachmentErrorMsg: '.ph-customerattachmeterrorshow',
  attachmentFileRow: '.ph-file-row',
  sessionTimeoutIdentifier: 'LOGIN_PAGE_IDENTIFIER_SESSION_TIMEOUT',
  fileError: false,
  isitsaporder: '#ph-isitsaporder',
  advSearchAnchor: '#advancedOrdersSearch',
  advSearchNotificationClass: '.ph-advancedSearchNotification',
  indicatorColorSelector: function(ordstatus) {
    var color = '';

    switch (ordstatus) {
        case 'open':
          color = '#5dafd1';

          break;
        case 'shipped':
          color = '#299f84';

          break;
        case 'completed':
          color = '#b0bd31';

          break;
        case 'cancelled':
          color = '#e03324';

          break;
        case 'canceled':
          color = '#e03324';

          break;
        case 'partially_received':
          color = '#f2c544';

          break;
        case 'partially_shipped':
          color = '#f2c544';

          break;
        case 'received':
          color = '#b0bd31';

          break;
        case 'awaiting_payment':
          color = '#0011cc';

          break;
        case 'blocked':
          color = '#cc00bb';

          break;
        case 'unknown':
          color = '#e03324';

          break;
        default:
          color = '#c1e4e6';

          break;
    }

    return color;
  },
  commondisplayorder: function(result, content, newordercount) {
    var orderhistoryRow = '',
        indicatorColor = '0',
        ordercontainer = '.ph-orderdetails_overview',
        orderCodeId = 0,
        localizedFinalOrderStatus = '';

    /* eslint-disable no-param-reassign */
    $.each(result, function(monthName, monthVal) {
      newordercount = newordercount + monthVal.length;
      content = content + '<div class="ph-col-12 ph-float-left ph-p-0 ph-ordermonthalgn">' +
'<div class="ph-col-12 ph-float-left ph-p-0 ph-my-2 ph-eachMonthBlock"><span class="ph-orderhistorymonth">' +
monthName + ' (' + monthVal.length + ')' +
'</span></div><div class="ph-col-12 ph-float-left ph-p-0 ph-wholemonthorder hidden">';
      $.each(monthVal, function(orderindex) {
        orderhistoryRow = monthVal[orderindex];
        localizedFinalOrderStatus = orderhistoryRow.localizedFinalOrderStatus;

        if (orderhistoryRow.code === '' || orderhistoryRow.code === null) {
          orderCodeId = orderhistoryRow.localHybrisOrderCode;
        } else {
          orderCodeId = orderhistoryRow.code;
        }

        if (orderhistoryRow.cancellationStatus && orderhistoryRow.cancellationStatus.toLowerCase() === 'cancelling') {
          localizedFinalOrderStatus = $('.cancelling_status_label').text();
          orderhistoryRow.finalOrderStatus = orderhistoryRow.cancellationStatus.toLowerCase();
        }

        indicatorColor = ACC.neworder.indicatorColorSelector(orderhistoryRow.finalOrderStatus);
        content = content +
'<div class="ph-col-12 ph-float-left ph-orderhistory_panel ph-p-0">' +
'<div id="ph-detailbar' + orderCodeId +
'" class="ph-col-12 ph-float-left ph-orderdetailbar ph-icon-arrow-down" data-ordercode= "' + orderCodeId +
'" data-localHybrisOrderCode= "' + orderhistoryRow.localHybrisOrderCode + '">' +
'<div class="ph-col-4 ph-col-md-3 ph-float-left ph-px-0">' +
'<span class="ph-col-12 ph-p-0 ph-d-block ph-font-weight-bold">' + orderhistoryRow.code + '</span>' +
'<span class="ph-col-12 ph-p-0 ph-d-block ph-txtalgn">' +
'<span>' + orderhistoryRow.purchaseOrderNumber + '</span></span>' +
'</div>' +
'<div class="ph-col-4 ph-col-md-3 ph-float-left ph-padtopalgn ph-txtcenteralgn">' +
'<span>' + orderhistoryRow.orderCreationDate + '</span>' +
'</div>' +
'<div class="ph-col-4 ph-col-md-3 ph-d-none ph-d-md-block ph-float-left ph-padtopalgn ph-breakorderword">' +
'<span>' + orderhistoryRow.documentName + '<br/>' + orderhistoryRow.documentType + '</span>' +
'</div>' +
'<div class="ph-float-left ph-px-0 ph-ordermrg ph-padtopalgn ph-txtalgn ph-padleftalgn ph-padleftalgn ph-d-flex ph-flex-row">' +
'<svg height="16" width="16">' +
'<circle cx="8" cy="6" r="4" fill="' + indicatorColor + '" /></svg>&nbsp;&nbsp;<span class="ph-oovstatustxt">' +
localizedFinalOrderStatus + '</span>' +
'</div>' +
'<span class="ph-interstitial-loader ph-orderhistory-loader hidden"></span>' +
'</div>' +
'<div id="orderPanel' + orderCodeId + '" class="ph-orderhistory_foldout ph-orderhistory_panelcollapse">' +
        '</div></div>';
      });
      content = content +
'</div></div>';
    });

    $(ordercontainer).html(content);
    $('.ph-ordercount').text(newordercount);

    if ($('#ph-isLocalOrderCreateEnable').val() === 'true' && $('#ph-notificationAdvancedSearch').length > 0 &&
!window.location.href.endsWith(ACC.neworder.advSearchAnchor)) {
      $('.ph-eachMonthBlock:first').prepend('<div class="ph-neworderresult ph-advancedSearchNotification">' +
      $('#ph-notificationAdvancedSearch').html() + '</div>');
    }

    if (newordercount === 0) {
      $(ordercontainer).addClass(ACC.neworder.hiddenClass);
      $(ACC.neworder.noordernewresult).removeClass(ACC.neworder.hiddenClass);
    } else {
      $(ordercontainer).removeClass(ACC.neworder.hiddenClass);
      $(ACC.neworder.noordernewresult).addClass(ACC.neworder.hiddenClass);
    }

    /* eslint-enable no-param-reassign */
  },
  removeInfoIconOnPopUp: function() {
    $('.ph-preicmipopup').each(function() {
      if ($(this).html().trim() === '') {
        $(this).prev('.ph-iconpreicmi').remove();
      }
    });
  },
  removeInfoIcononFoldout: function() {
    $('.ph-orderwithdiscount').each(function() {
      if ($(this).find('.ph-popuptext').html().trim() === '') {
        $(this).parents('.ph-financialinfo-wrap').find('.ph-icon').remove();
      }
    });
  },
  isSapOrderType: function() {
    return $(ACC.neworder.isitsaporder).val();
  },
  getOrderDetailsByID: function(orderCode, localOrderId) {
    $.ajax({
      url: ACC.config.encodedContextPath + '/orderhistory/accountOrders/order',
      data: {
        orderCode: orderCode,
        isSapOrders: ACC.neworder.isSapOrderType(),
        localHybrisOrderCode: localOrderId
      },
      type: 'GET',
      dataType: 'html',
      success: function(data) {
        var maxWidth = 0,
            newreorderButton = 'newreorderButton',
            newreturnButton = 'newreturnButton';

        if (data.indexOf(ACC.neworder.sessionTimeoutIdentifier) !== -1) {
          window.location.reload();
        } else {
          $('.' + ACC.neworder.activeCls).hide();
          $('#' + ACC.neworder.detailsBarCls + orderCode).addClass('ph-content-loaded');
          $('#' + ACC.neworder.orderPanelCls + orderCode).html(data);
          ACC.neworder.removeInfoIcononFoldout();
          ACC.neworder.removeInfoIconOnPopUp();
          $('#' + ACC.neworder.detailsBarCls + orderCode).find('.ph-' + ACC.neworder.orderfoldoutloader).addClass(ACC.neworder.hiddenClass);
          $('#' + ACC.neworder.orderPanelCls + orderCode).show(300);
          $(ACC.neworder.orderHistoryPanelCls).removeClass(ACC.neworder.activePanelCls);
          $('#' + ACC.neworder.detailsBarCls + orderCode).parents(ACC.neworder.orderHistoryPanelCls).addClass(ACC.neworder.activePanelCls);
          $('#' + ACC.neworder.orderPanelCls + orderCode).addClass(ACC.neworder.activeCls);
          $('.ph-' + ACC.neworder.orderfoldoutloader).addClass('hidden');
          $('.' + ACC.neworder.orderdetailbar).removeClass(ACC.neworder.upArrowCls).addClass(ACC.neworder.downArrowCls);
          $('#' + ACC.neworder.detailsBarCls + orderCode).removeClass(ACC.neworder.downArrowCls).addClass(ACC.neworder.upArrowCls);
          $('#' + ACC.neworder.detailsBarCls + orderCode).focus();
          $('.' + ACC.neworder.orderdetailbar).removeAttr(ACC.neworder.tabindex);
          $.colorbox.close();
          $('.ph-' + ACC.neworder.orderfoldbar).css(ACC.neworder.pointerEventsAttr, 'auto');
          $('.ph-orderhistory_listitem').each(function() {
            var statusinfoprod = $(this).find('.ph-prodeachstatus').val(),
                statuscolorcode = ACC.neworder.indicatorColorSelector(statusinfoprod);

            $(this).find('circle').css({
              fill: statuscolorcode
            });
          });

          $('.ph-widproditem').each(function() {
            maxWidth = Math.max(maxWidth, $(this).width());
          }).width(maxWidth);

          if ($('#' + ACC.neworder.detailsBarCls + orderCode).text().indexOf('YAOR') >= 0) {
            $('#' + ACC.neworder.orderPanelCls + orderCode).find('#ph-' + newreorderButton).show();
            $('#' + ACC.neworder.orderPanelCls + orderCode).find('#ph-' + newreturnButton).show();
          } else {
            $('#' + ACC.neworder.orderPanelCls + orderCode).find('#ph-' + newreorderButton).hide();
            $('#' + ACC.neworder.orderPanelCls + orderCode).find('#ph-' + newreturnButton).hide();
          }
        }
      },
      error: function() {
        window.location.reload();
      }
    });
  },
  fetchAdvanceSearchDetails: function(searchParam) {
    var content = '',
        divId = '',
        $wholecontainer = '';

    $.ajax({
      url: ACC.config.encodedContextPath + '/orderhistory/search-all-orders',
      data: {
        orderType: searchParam.orderType,
        orderNo: searchParam.orderNo,
        productCodeType: searchParam.productCodeType,
        salesOrg: searchParam.salesOrg,
        productCode: searchParam.productCode,
        purchaseOrderNumber: searchParam.purchaseOrderNumber,
        shippingStatus: searchParam.shippingStatus,
        orderCreatedFromDate: searchParam.orderCreatedFromDate,
        orderCreatedToDate: searchParam.orderCreatedToDate,
        sort: searchParam.sort
      },
      type: 'POST',
      datatype: 'json',
      success: function(data) {
        $(ACC.neworder.overlayCls).hide();
        $('.' + ACC.neworder.advancedSearchCls).css(ACC.neworder.pointerEventsAttr, 'all');
        $('.' + ACC.neworder.advSearchLoader).addClass(ACC.neworder.hiddenClass);

        if ($.isEmptyObject(data)) {
          $(ACC.neworder.noordernewresult).removeClass(ACC.neworder.hiddenClass);
          $(ACC.neworder.noordernewresult).removeClass('ph-px-0');
          $('.' + ACC.neworder.advSearchLink).addClass(ACC.neworder.hiddenClass);
          $('.' + ACC.neworder.ordetailsOverview).html('');
        } else {
          ACC.neworder.commondisplayorder(data, content, 0);
          $(ACC.neworder.noordernewresult).addClass(ACC.neworder.hiddenClass);
          $('.' + ACC.neworder.advSearchLink).removeClass(ACC.neworder.hiddenClass);
          $('.' + ACC.neworder.advSearchLink).removeClass(ACC.neworder.paddingZero);
          $('.' + ACC.neworder.ordetailsOverview).removeClass(ACC.neworder.paddingZero);
          $('.' + ACC.neworder.ordetailsOverview).removeClass(ACC.neworder.hiddenClass);
          $('.' + ACC.neworder.ordetailsOverview).addClass('ph-advSearch_results');
          $wholecontainer = $('.' + ACC.neworder.monthTabCls);

          if ($wholecontainer.length > 0) {
            $('.' + ACC.neworder.monthTabCls).first().removeClass(ACC.neworder.hiddenClass);
          }

          if (window.location.href.includes('orderCode')) {
            divId = '#' + ACC.neworder.detailsBarCls + searchParam.orderNo;
            $(window).scrollTop($('.' + ACC.neworder.advSearchLink).offset().top - 100);
            $(divId).find('.ph-' + ACC.neworder.orderfoldoutloader).removeClass(ACC.neworder.hiddenClass);
            $(divId).removeClass(ACC.neworder.downArrowCls);
            ACC.neworder.getOrderDetailsByID(searchParam.orderNo);
          }
        }
      },
      error: function() {
        $('.' + ACC.neworder.advancedSearchCls).css(ACC.neworder.pointerEventsAttr, 'all');
        $('.' + ACC.neworder.advSearchLoader).addClass(ACC.neworder.hiddenClass);
      }
    });
  },
  toggleOrderDetailsPanel: function(orderId) {
    if ($('#' + ACC.neworder.detailsBarCls + orderId).hasClass(ACC.neworder.upArrowCls)) {
      $('#' + ACC.neworder.orderPanelCls + orderId).hide(300);
      $('#' + ACC.neworder.orderPanelCls + orderId).removeClass(ACC.neworder.activeCls);
      $('#' + ACC.neworder.detailsBarCls + orderId).removeClass(ACC.neworder.upArrowCls).addClass(ACC.neworder.downArrowCls);
      $(ACC.neworder.orderHistoryPanelCls).removeClass(ACC.neworder.activePanelCls);
      $('.' + ACC.neworder.orderdetailbar).removeAttr(ACC.neworder.tabindex);
    } else {
      $('#' + ACC.neworder.orderPanelCls + orderId).show(300);
      $(ACC.neworder.orderHistoryPanelCls).removeClass(ACC.neworder.activePanelCls);
      $('#' + ACC.neworder.detailsBarCls + orderId).parents(ACC.neworder.orderHistoryPanelCls).addClass(ACC.neworder.activePanelCls);
      $('#' + ACC.neworder.orderPanelCls + orderId).addClass(ACC.neworder.activeCls);
      $('.' + ACC.neworder.orderdetailbar).removeClass(ACC.neworder.upArrowCls).addClass(ACC.neworder.downArrowCls);
      $('#' + ACC.neworder.detailsBarCls + orderId).removeClass(ACC.neworder.downArrowCls).addClass(ACC.neworder.upArrowCls);
      setTimeout(function() {
        $('#' + ACC.neworder.detailsBarCls + orderId).focus();
        $('.' + ACC.neworder.orderdetailbar).removeAttr(ACC.neworder.tabindex);
      }, 200);
    }
  },
  downloadFileInIE: function(data, fileName) {
    var byteCharacters = '0',
        byteNumbers = 0,
        inc = 0,
        byteArray = '0',
        blob = '0';

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      byteCharacters = atob(data);
      byteNumbers = [byteCharacters.length];

      for (inc; inc < byteCharacters.length; inc = inc + 1) {
        byteNumbers[inc] = byteCharacters.charCodeAt(inc);
      }

      /* eslint-disable no-undef */
      byteArray = new Uint8Array(byteNumbers);
      /* eslint-enable no-undef */
      blob = new Blob([byteArray], {
        type: 'application/pdf'
      });

      window.navigator.msSaveOrOpenBlob(blob, fileName);
    }
  },
  invoicepdflink: function(billDocNum) {
    $.ajax({
      type: 'GET',
      url: ACC.config.encodedContextPath + '/my-account/generateBillingDoc?billingDocId=' + billDocNum,
      success: function(data) {
        var uri = 'data:application/pdf;base64, ' + data;
        var link = document.createElement('a');
        /* eslint-disable id-match */
        var isIE = Boolean(document.documentMode);

        /* eslint-enable id-match */
        /* @cc_on!@*/

        if (!isIE) {
          link.href = uri;
          link.download = billDocNum + '.pdf';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          ACC.neworder.downloadFileInIE(data, billDocNum + '.pdf');
        }
      },
      error: function() {
        $('#pdf-button').hide();
        $('#pdf-error').show();
      }
    });
  },
  generatedownloadorder: function(orderCode) {
    $.ajax({
      url: ACC.config.encodedContextPath + '/pdfreports/download',
      data: {
        orderCode: orderCode
      },
      type: 'GET',
      datatype: 'json',
      success: function() {
        $.colorbox({
          width: '450px',
          maxWidth: '90%',
          html: $('.ph-reportgeneration').html(),
          overlayClose: false,
          onComplete: function() {
            $('.ph-generatereportredirect').attr('href', ACC.config.encodedContextPath + '/reports?reporttrigger');
          },
          onClosed: function() {
            ACC.common.refreshScreenReaderBuffer();
          }
        });
      },
      error: function() {
        window.location.reload();
      }
    });
  },
  getcommonsortfilterDetails: function(selectedoption) {
    var content = '',
        newordercount = 0,
        $wholecontainer = '';

    $(ACC.neworder.overlayCls).show();
    $.ajax({
      url: ACC.config.encodedContextPath + '/orderhistory/search-filtered-orders',
      data: {
        orderTypeFilter: selectedoption.orderTypeFilter,
        statusFilter: selectedoption.statusFilter,
        dateFilter: selectedoption.dateFilter,
        sort: selectedoption.sort
      },
      type: 'POST',
      datatype: 'json',
      beforeSend: function() {
        $(ACC.neworder.overlayCls).removeClass(ACC.neworder.hiddenClass);
      },
      success: function(data) {
        $(ACC.neworder.isitsaporder).val(data.isSapOrders);
        ACC.neworder.commondisplayorder(data.orderHistoryMap, content, newordercount);
        $wholecontainer = $('.' + ACC.neworder.monthTabCls);

        if ($wholecontainer.length > 0 && selectedoption.sort !== 'orderstatus') {
          $('.' + ACC.neworder.monthTabCls).first().removeClass(ACC.neworder.hiddenClass);
        }

        $(ACC.neworder.overlayCls).hide();
      },
      error: function() {
        window.location.reload();
      }
    });
  },
  getadvancesortDetails: function(selectedadvanceoption) {
    var content = '',
        $wholecontainer = '';

    $(ACC.neworder.overlayCls).show();
    $.ajax({
      url: ACC.config.encodedContextPath + '/orderhistory/search-all-orders',
      data: {
        orderType: selectedadvanceoption.orderType,
        sort: selectedadvanceoption.sort,
        orderNo: selectedadvanceoption.orderNo,
        productCodeType: selectedadvanceoption.productCodeType,
        salesOrg: selectedadvanceoption.salesOrg,
        productCode: selectedadvanceoption.productCode,
        purchaseOrderNumber: selectedadvanceoption.purchaseOrderNumber,
        orderCreatedFromDate: selectedadvanceoption.orderCreatedFromDate,
        orderCreatedToDate: selectedadvanceoption.orderCreatedToDate,
        shippingStatus: selectedadvanceoption.shippingStatus
      },
      type: 'POST',
      datatype: 'json',
      success: function(data) {
        ACC.neworder.commondisplayorder(data, content, 0);
        $wholecontainer = $('.' + ACC.neworder.monthTabCls);

        if ($wholecontainer.length > 0 && selectedadvanceoption.sort !== 'orderstatus') {
          $('.' + ACC.neworder.monthTabCls).first().removeClass(ACC.neworder.hiddenClass);
        }

        $(ACC.neworder.overlayCls).hide();
      },
      error: function() {
        window.location.reload();
      }
    });
  },
  checkForAttachmentComment: function() {
    var isCommentValid = 0;

    if ($(ACC.neworder.commentInputId).is(':visible') && $(ACC.neworder.commentInputId).val() === '') {
      $(ACC.neworder.commentInputId).parent().addClass(ACC.neworder.formErrorLabel);
      $('.ph-customerattachmeterrormsg').show();
      isCommentValid = 0;
    } else {
      $(ACC.neworder.commentInputId).parent().removeClass(ACC.neworder.formErrorLabel);
      $('.ph-customerattachmeterrormsg').hide();
      isCommentValid = 1;
    }

    return isCommentValid;
  },
  checkForFormErrors: function(returncustomerid, selectreasoncode) {
    var isFormValid = 0;

    if ($(ACC.neworder.formErrorCls).length === 0 && $(returncustomerid).val() !== '' && $(selectreasoncode).val() !== 'default') {
      isFormValid = 1;
    } else {
      isFormValid = 0;
    }

    return isFormValid;
  },
  checkForQunatityAdded: function(selreturnqtyid) {
    var quantityAdded = '';

    $(selreturnqtyid).each(function() {
      if (parseInt($(this).val(), 10) > 0) {
        quantityAdded = 1;

        return false;
      }

      quantityAdded = 0;

      return true;
    });

    return quantityAdded;
  },
  createProductListForCancel: function(orderCode) {
    var list = $('#' + ACC.neworder.orderPanelCls + orderCode).find('.ph-orderhistory_productlist .ph-orderhistory_listitem'),
        productArr = [];

    list.each(function() {
      var product = {
        id: '',
        quantity: ''
      };

      if ($(this).attr('data-prdctv').length > 0) {
        product.id = $(this).attr('data-prdctv');
      } else {
        product.id = $(this).attr('data-prdcode');
      }

      product.quantity = $(this).attr('data-prdqty');
      productArr.push(product);
    });

    return productArr;
  },
  fetchOrderByOrderCode: function(selectedcommonoption) {
    var orderCodeText = window.location.href,
        orderCode = '',
        searchParam = {
          orderType: 'mixedOrderTypes',
          orderNo: '',
          productCodeType: '',
          salesOrg: '',
          productCode: '',
          purchaseOrderNumber: '',
          shippingStatus: '',
          orderCreatedFromDate: '',
          orderCreatedToDate: '',
          sort: ''
        };

    if (orderCodeText.includes('orderCode')) {
      orderCode = orderCodeText.split('?')[1];
      orderCode = orderCode.split('=')[1];
      // eslint-disable-next-line no-ternary
      searchParam.orderNo = orderCode.length === 10 ? orderCode.replace(/^0/, '') : orderCode;
      ACC.neworder.showAdvanceSearchBlock();
      ACC.neworder.fetchAdvanceSearchDetails(searchParam);
    } else {
      ACC.neworder.getcommonsortfilterDetails(selectedcommonoption);
    }
  },
  showAdvanceSearchBlock: function() {
    $('.ph-hide-advsearch').addClass(ACC.neworder.hiddenClass);
    $(ACC.neworder.noordernewresult).addClass(ACC.neworder.hiddenClass);
    $('.' + ACC.neworder.advancedSearchCls).removeClass(ACC.neworder.hiddenClass);
    $('#kampyleFormContainer').css('height', '100%');
    $(document).on('DOMNodeInserted', ACC.neworder.advSearchNotificationClass, function() {
      $(ACC.neworder.advSearchNotificationClass).addClass('hidden');
    });
  },
  validateAttachment: function() {
    var jpgType = 'image/jpeg',
        pdfType = 'application/pdf',
        pngType = 'image/png',
        ind = 0,
        fileType = '';

    for (ind; ind < ACC.neworder.uploadedAttachement.length; ind = ind + 1) {
      fileType = ACC.neworder.uploadedAttachement[ind].file.type;

      if (ACC.neworder.uploadedAttachement[ind].file.size > 5000000) {
        $(ACC.neworder.attachmentFileRow + ind).addClass(ACC.neworder.formErrorCls);
      } else if (fileType !== jpgType && fileType !== pdfType && fileType !== pngType) {
        $(ACC.neworder.attachmentFileRow + ind).addClass(ACC.neworder.formErrorCls);
      } else {
        $(ACC.neworder.attachmentFileRow + ind).removeClass(ACC.neworder.formErrorCls);
      }
    }
  },
  salesorgval: function(salesorgstore) {
    var salesorgmapping = '#salesorgmapping',
        salesorgstoreval = '';

    if ($(salesorgmapping).length > 0) {
      salesorgstoreval = $(salesorgmapping).val();
    } else {
      salesorgstoreval = salesorgstore;
    }

    return salesorgstoreval;
  },
  validateFileSize: function(file) {
    var fileMaxlimit = 'true';

    if (file.size === 0 || file.size > 10000000) {
      fileMaxlimit = 'false';
      ACC.neworder.fileError = true;
    }

    return fileMaxlimit;
  },
  showFileMaxSizeError: function() {
    var errorMsg = $.trim($('.ph-fileSizeErrmsg').text());

    if (ACC.neworder.fileError === true) {
      $(ACC.neworder.attachmentErrorMsg).html(errorMsg);
      $(ACC.neworder.attachmentErrorMsg).removeClass(ACC.neworder.hiddenClass).show();
    } else {
      $(ACC.neworder.attachmentErrorMsg).html('');
      $(ACC.neworder.attachmentErrorMsg).addClass(ACC.neworder.hiddenClass).hide();
    }

    ACC.neworder.fileError = false;
  }
};

$(document).ready(function() {
  $(document).on('click', '.ph-' + ACC.neworder.orderfoldbar, function() {
    var orderAtCode = 'ordercode',
        orderId = $(this).attr('data-' + orderAtCode);
    var localOrderId = $(this).attr('data-localhybrisordercode');

    $(this).attr(ACC.neworder.tabindex, -1);

    if ($(this).hasClass(ACC.neworder.downArrowCls)) {
      $(this).find('.ph-' + ACC.neworder.orderfoldoutloader).removeClass(ACC.neworder.hiddenClass);
      $('.ph-' + ACC.neworder.orderfoldbar).css(ACC.neworder.pointerEventsAttr, 'none');
      ACC.neworder.getOrderDetailsByID(orderId, localOrderId);
      $(this).removeClass(ACC.neworder.downArrowCls);
    } else {
      $('.' + ACC.neworder.activeCls).hide(300);
      ACC.neworder.toggleOrderDetailsPanel(orderId);
    }
  });
  $(document).on('click', '.ph-pdfreportdownload__button', function() {
    var orderhistoryPanel = 'orderhistory_panel',
        orderAtCode = 'ordercode',
        orderCode = $(this).parents('.ph-' + orderhistoryPanel).find('.ph-' + ACC.neworder.orderfoldbar).attr('data-' + orderAtCode);

    ACC.neworder.generatedownloadorder(orderCode);
  });
  $(document).on('mouseout', '.ph-netprice__ordericon', function() {
    $(this).find('.ph-netprice__popup').addClass(ACC.neworder.hiddenClass);
  });
  $(document).on('mouseover', '.ph-netprice__ordericon', function() {
    $(this).find('.ph-netprice__popup').removeClass(ACC.neworder.hiddenClass);
  });
});
$(document).ready(function() {
  /* eslint-disable max-len */
  function createUserEventObj(url, desc, trigger, compname) {
    return {
      url: url,
      description: desc,
      trigger: trigger,
      compname: compname
    };
  }

  function createEcommerceEventObj(trigger, returnId, returnReason, orginalOrdId) {
    return {
      trigger: trigger,
      returnId: returnId,
      returnReason: returnReason,
      orginalOrdId: orginalOrdId
    };
  }

  function getProductObjectGoogleAnalytics(index, userReturnQty) {
    var gaproductclass = '.ph-returnEntries-' + index,
        gactvclass = '.ph-ctvValue-' + index,
        productCtvValue = $(gactvclass).attr('data-productctv'),
        productIdValue = $(gaproductclass).attr('data-productcode'),
        productId = '';

    /* eslint-disable no-undefined*/
    if (productCtvValue !== '' && productCtvValue !== undefined) {
      productId = productCtvValue;
    } else {
      productId = productIdValue;
    }

    /* eslint-enable no-undefined*/
    return {
      id: productId,
      quantity: userReturnQty
    };
  }

  function trackReturnProdGoogleAnalytics(prodindex, totalNoOfProducts) {
    var product = {},
        productsArray = [],
        index = 0,
        trigger = 'ecommerce.checkout.refund',
        returnId = $('.ph-pwdinput.ph-returnorderValidation').val(),
        returnReason = $('.ph-selectreasonfield').val(),
        orderAtCode = 'ordercode',
        orginalOrdId = $('.ph-orderdetailbar.ph-icon-arrow-up').attr('data-' + orderAtCode),
        userReturnQty = 0,
        ecommerceEventObj = '';

    for (index = prodindex; index < totalNoOfProducts; index = index + 1) {
      userReturnQty = $('input[name="returnEntries[' + index + '].userReturnQty"]').val();

      if (userReturnQty > 0) {
        product = getProductObjectGoogleAnalytics(index, userReturnQty);
        productsArray.push(product);
      }
    }

    ecommerceEventObj = createEcommerceEventObj(trigger, returnId, returnReason, orginalOrdId);

    ACC.googleanalytics.gaEventsForReturnOrder(ecommerceEventObj, productsArray);
  }

  $(document).on('click', '.ph-viewBillingDoc', function() {
    var txtOrderId = 'orderId',
        orderId = $(this).attr('data-' + txtOrderId),
        billDocNum = $(this).attr('data-billDocNum'),
        purchaseOrderRefNumber = $(this).attr('data-purchaseOrderRefNumber'),
        entryNum = $(this).attr('data-uniqueentrynum'),
        billingType = $(this).attr('data-billingType');

    $('.' + entryNum).show();
    $(ACC.neworder.overlayCls).show();
    $.ajax({
      url: ACC.config.encodedContextPath + '/orderhistory/viewBillingDoc',
      data: {
        orderCode: orderId,
        billDocNum: billDocNum,
        purchaseOrderRefNumber: purchaseOrderRefNumber,
        billingType: billingType
      },
      type: 'GET',
      datatype: 'html',
      success: function(result) {
        if (result.indexOf(ACC.neworder.sessionTimeoutIdentifier) !== -1) {
          window.location.reload();
        } else {
          $('.' + entryNum).hide();
          $.colorbox({
            html: result,
            maxWidth: '842px',
            width: '90%',
            height: 'auto',
            overlayClose: true,
            onOpen: function() {
              $(document).on('click', '.ph-pdfbilllink', function() {
                ACC.neworder.invoicepdflink(billDocNum);
              });
              $(document).on('click', '.ph-closebtn', function() {
                $.colorbox.close();
              });
            },
            onComplete: function() {
              var billingdocpopup = 'billingdocpopup',
                  billingdocpopupwithoutdisc = 'billingdocpopupwithoutdisc';

              ACC.neworder.removeInfoIconOnPopUp();

              if ($('.ph-' + billingdocpopup, '.ph-' + billingdocpopupwithoutdisc).length > 0) {
                if ($('.ph-' + billingdocpopup, '.ph-' + billingdocpopupwithoutdisc).find('.ph-popupsubtotal').find('.ph-popuptext').html().trim() === '') {
                  $('.ph-' + billingdocpopup, '.ph-' + billingdocpopupwithoutdisc).find('.ph-icon').remove();
                }
              }
            },
            onClosed: function() {
              $('body').css('overflow', 'auto');
              $(document).off('click', '.ph-pdfbilllink');
            }
          });
          $(ACC.neworder.overlayCls).hide();
        }
      },
      error: function() {
        window.location.reload();
      }
    });
  });
  $(document).on('click', '.ph-viewDeliveryDoc', function() {
    var orderId = $(this).attr('data-orderId'),
        delivDocNum = $(this).attr('data-delivDocNum'),
        purchaseOrderRefNumber = $(this).attr('data-purchaseOrderRefNumber'),
        entryNum = $(this).attr('data-uniqueentrynum'),
        sapPlant = $(this).attr('sapPlant'),
        sapPlantDescription = $(this).attr('sapPlantDescription'),
        totalVolume = $(this).attr('totalVolume'),
        totalWeight = $(this).attr('totalWeight'),
        totalVolumeUnit = $(this).attr('totalVolumeUnit'),
        totalWeightUnit = $(this).attr('totalWeightUnit');

    $('.' + entryNum).show();
    $(ACC.neworder.overlayCls).show();
    $.ajax({
      url: ACC.config.encodedContextPath + '/orderhistory/viewDeliveryDoc',
      data: {
        orderCode: orderId,
        delivDocNum: delivDocNum,
        purchaseOrderRefNumber: purchaseOrderRefNumber,
        sapPlant: sapPlant,
        sapPlantDescription: sapPlantDescription,
        totalVolume: totalVolume,
        totalWeight: totalWeight,
        totalVolumeUnit: totalVolumeUnit,
        totalWeightUnit: totalWeightUnit
      },
      type: 'GET',
      datatype: 'html',

      success: function(data) {
        if (data.indexOf(ACC.neworder.sessionTimeoutIdentifier) !== -1) {
          window.location.reload();
        } else {
          $('.' + entryNum).hide();
          $.colorbox({
            html: data,
            maxWidth: '842px',
            width: '90%',
            height: 'auto',
            overlayClose: true,
            onOpen: function() {
              $(document).on('click', '.ph-closebtn', function() {
                $.colorbox.close();
              });
            },
            onClosed: function() {
              $('body').css('overflow', 'auto');
            }
          });
          $(ACC.neworder.overlayCls).hide();
        }
      },
      error: function() {
        window.location.reload();
      }
    });
  });
  /* eslint-enable max-len */
  $(document).on('click', '#ph-newcancelButton', function() {
    var orderCode = $(this).attr('data-oncanorder');

    $('.ph-newcancelorder__yes, #ph-confirmCancel').attr(ACC.neworder.canOrderid, orderCode);
    $.colorbox({
      width: '500px',
      maxWidth: '90%',
      height: '180px',
      html: $('#' + orderCode).html(),
      overlayClose: false,
      closeButton: true,
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  });
  $(document).on('click', '.ph-newcancelorder__yes', function() {
    var orderCode = $(this).attr(ACC.neworder.canOrderid),
        products = '',
        localOrderId = $(this).attr('data-localhybrisordercode');

    $(this).find('.ph-' + ACC.neworder.orderfoldoutloader).removeClass(ACC.neworder.hiddenClass);

    $(this).addClass(ACC.neworder.disabledBtnCls);
    $('.ph-returnorder__no').addClass(ACC.neworder.disabledBtnCls);
    products = ACC.neworder.createProductListForCancel(orderCode);

    if (orderCode === localOrderId) {
      orderCode = '';
    }

    $.ajax({
      url: ACC.config.encodedContextPath + '/cancel/order',
      data: {
        orderCode: orderCode,
        isSapOrders: ACC.neworder.isSapOrderType(),
        localHybrisOrderCode: localOrderId
      },
      type: 'POST',
      datatype: 'json',
      success: function(result) {
        ACC.googleanalytics.gaEventForCancelOrder(products, orderCode);

        if (result === 'Received') {
          $.colorbox({
            width: '450px',
            maxWidth: '90%',
            height: '180px',
            html: $('.ph-cancel_orderreceived').html(),
            overlayClose: false
          });
        } else if (result === 'Success') {
          $.colorbox({
            width: '450px',
            maxWidth: '90%',
            height: '180px',
            html: $('.ph-cancel_orderconf').html(),
            overlayClose: false
          });
        } else if (result === 'Failure') {
          $.colorbox({
            width: '450px',
            maxWidth: '90%',
            height: '180px',
            html: $('.ph-cancel_ordererror').html(),
            overlayClose: false,
            onComplete: function() {
              ACC.common.refreshScreenReaderBuffer();
            },
            onClosed: function() {
              ACC.common.refreshScreenReaderBuffer();
            }
          });
        }
      },
      error: function() {
        window.location.reload();
      }
    });
  });
  $(document).on('click', '#ph-confirmCancel', function() {
    var orderCode = $(this).attr(ACC.neworder.canOrderid),
        cancelstatus = $('.ph-cancelstatus').val();

    $(this).addClass(ACC.neworder.disabledBtnCls);

    if ($('#' + ACC.neworder.detailsBarCls + orderCode).hasClass(ACC.neworder.upArrowCls)) {
      $('.ph-icon-arrow-up').find('.ph-oovstatustxt').text(cancelstatus);
      $('.ph-icon-arrow-up').find('circle').css({
        fill: '#e03324'
      });
    }

    if (orderCode) {
      ACC.neworder.getOrderDetailsByID(orderCode);
    } else {
      window.location.reload();
    }

    $(this).find('.ph-' + ACC.neworder.orderfoldoutloader).removeClass(ACC.neworder.hiddenClass);
  });
  $(document).on('click', '#ph-newreturnButton', function() {
    var newOrderCode = $('.ph-returnorderpopupcode').val(),
        urlLink = window.location.href,
        trigger = 'linkCategory.clickReturnOrder',
        compname = 'linkReturnOrder',
        desc = 'Return Order ' + newOrderCode,
        userEventObj = '';

    userEventObj = createUserEventObj(urlLink, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });
  $(document).on('click', '.ph-returnordersubmit', function() {
    var $productList = $('.ph-returnprodtable .ph-orderprodDetails'),
        totalNoOfProducts = $productList.length;

    trackReturnProdGoogleAnalytics(0, totalNoOfProducts);
  });
  $(document).on('click', '.ph-reorder_btn', function() {
    var orderCode = $(this).attr('data-orderId'),
        localOrderId = $(this).attr('data-localHybrisOrderCode'),
        quickorderurl = window.location.protocol + '//' + window.location.host + ACC.config.encodedContextPath + '/importOrder/reorder',
        orderhistoryPanel = 'orderhistory_panel',
        orderAtCode = 'ordercode',
        newOrderCode = $(this).parents('.ph-' + orderhistoryPanel).find('.ph-' + ACC.neworder.orderfoldbar).attr('data-' + orderAtCode),
        urlLink = '',
        trigger = 'linkCategory.clickReorder',
        compname = 'linkReorder',
        desc = 'Reorder ' + newOrderCode,
        userEventObj = '';

    $(this).find('.ph-' + ACC.neworder.orderfoldoutloader).removeClass(ACC.neworder.hiddenClass);

    $(this).addClass(ACC.neworder.disabledBtnCls);
    $(ACC.neworder.overlayCls).show();
    $.ajax({
      url: ACC.config.encodedContextPath + '/orderhistory/reorder/order',
      data: {
        orderCode: orderCode,
        isSapOrders: ACC.neworder.isSapOrderType(),
        localHybrisOrderCode: localOrderId
      },
      type: 'POST',
      datatype: 'json',
      success: function(result) {
        if (result === 'Success') {
          urlLink = quickorderurl;
          userEventObj = createUserEventObj(urlLink, desc, trigger, compname);
          ACC.googleanalytics.gaEventsForLinks(userEventObj);
          /* eslint-disable xss/no-location-href-assign */
          window.location.href = quickorderurl;
          /* eslint-enable xss/no-location-href-assign */
        } else if (result === 'Failure') {
          urlLink = window.location.href;
          $.colorbox({
            width: '450px',
            maxWidth: '90%',
            height: '180px',
            html: $('.ph-reorder_error').html(),
            overlayClose: false
          });
          userEventObj = createUserEventObj(urlLink, desc, trigger, compname);
          ACC.googleanalytics.gaEventsForLinks(userEventObj);
        }

        $(ACC.neworder.overlayCls).hide();
      },
      error: function() {
        window.location.reload();
      }
    });
  });
});
$(document).ready(function() {
  var filterorderlist = '#ph-filterorderlist',
      filterstatuslist = '#ph-filterstatuslist',
      filterdatelist = '#ph-filterdatelist',
      firstchild = 'first-child',
      checkmarkspan = '<span class="ph-orderselectoption ph-icon-checkmark"></span>',
      orderselectoption = 'orderselectoption',
      productCodeType = '#productCodeType',
      ordersortmenu = '.ph-ordersort-menutooltip',
      sortlistitem = '.ph-sortlistitem',
      advshippingStatus = '#shippingStatus',
      selectedoption = {},
      selectedadvanceoption = {},
      selectedfilteroption = {},
      selectedcommonoption = {
        orderTypeFilter: $(filterorderlist).find('li:' + firstchild).attr('value'),
        statusFilter: $(filterstatuslist).find('li:' + firstchild).attr('value'),
        dateFilter: $(filterdatelist).find('li:' + firstchild).attr('value'),
        sort: $('.ph-sortoptionlist').find('li:' + firstchild).attr('value')
      },
      salesorgstore = '';

  if ($('.ph-orderhistorycontent').length > 0) {
    $('.ph-neworder-menu ul li:first-child').append(checkmarkspan);
    ACC.neworder.fetchOrderByOrderCode(selectedcommonoption);
    $(document).on('click', '.ph-orderhistorymonth', function() {
      var wholemonthorder = 'wholemonthorder';

      $(this).parents('.ph-ordermonthalgn').find('.ph-' + wholemonthorder).toggleClass(ACC.neworder.hiddenClass);
    });
  }

  $(document).on('click', sortlistitem, function() {
    var sortvalue = $(this).attr('value');

    $(sortlistitem).find('.ph-' + orderselectoption).remove();
    $(this).append(checkmarkspan);


    if (!$('.ph-advsearch-links').is(':visible')) {
      selectedoption = {
        orderTypeFilter: $(filterorderlist).find('.ph-' + orderselectoption).parent().attr('value'),
        statusFilter: $(filterstatuslist).find('.ph-' + orderselectoption).parent().attr('value'),
        dateFilter: $(filterdatelist).find('.ph-' + orderselectoption).parent().attr('value'),
        sort: sortvalue
      };

      ACC.neworder.getcommonsortfilterDetails(selectedoption);
    } else {
      salesorgstore = ACC.neworder.salesorgval(salesorgstore);

      selectedadvanceoption = {
        orderType: $('input[name="orderType"]:checked').val(),
        sort: sortvalue,
        orderNo: $('#orderNo').val(),
        productCodeType: $(productCodeType).val(),
        salesOrg: salesorgstore,
        productCode: $('#productCode').val(),
        purchaseOrderNumber: $('#purchaseOrderNumber').val(),
        orderCreatedFromDate: $('input[name="orderCreatedFromDate"]').val(),
        orderCreatedToDate: $('input[name="orderCreatedToDate"]').val(),
        shippingStatus: ''
      };

      if ($(advshippingStatus).val() !== 'd') {
        selectedadvanceoption.shippingStatus = $(advshippingStatus).val();
      }

      ACC.neworder.getadvancesortDetails(selectedadvanceoption);
    }
  });
  $(document).on('click', '.ph-filterlistitem', function() {
    $(this).parents('ul').find('.ph-' + orderselectoption).remove();
    $(this).append(checkmarkspan);

    selectedfilteroption = {
      orderTypeFilter: $(filterorderlist).find('.ph-' + orderselectoption).parent().attr('value'),
      statusFilter: $(filterstatuslist).find('.ph-' + orderselectoption).parent().attr('value'),
      dateFilter: $(filterdatelist).find('.ph-' + orderselectoption).parent().attr('value'),
      sort: $('.ph-sortoptionlist').find('.ph-' + orderselectoption).parent().attr('value')
    };
    ACC.neworder.getcommonsortfilterDetails(selectedfilteroption);
  });

  function executeAdvSearchByDefault() {
    var uri = window.location.toString(),
        cleanuri = '',
        searchParam = '';

    salesorgstore = ACC.neworder.salesorgval(salesorgstore);

    if (uri.indexOf('?') >= 1) {
      cleanuri = uri.substring(0, uri.indexOf('?'));

      window.history.replaceState({}, document.title, cleanuri);
    }

    searchParam = {
      orderType: $('input[name="orderType"]:checked').val(),
      orderNo: $('#orderNo').val(),
      productCodeType: $(productCodeType).val(),
      salesOrg: salesorgstore,
      productCode: $('#productCode').val(),
      purchaseOrderNumber: $('#purchaseOrderNumber').val(),
      shippingStatus: '',
      orderCreatedFromDate: $('input[name="orderCreatedFromDate"]').val(),
      orderCreatedToDate: $('input[name="orderCreatedToDate"]').val(),
      sort: ''
    };


    if ($(advshippingStatus).val() !== 'd') {
      searchParam.shippingStatus = $(advshippingStatus).val();
    }

    $('.ph-advsearch-loader').removeClass(ACC.neworder.hiddenClass);
    $(this).parents('.' + ACC.neworder.advancedSearchCls).css(ACC.neworder.pointerEventsAttr, 'none');
    ACC.neworder.fetchAdvanceSearchDetails(searchParam);
    $(ordersortmenu).addClass(ACC.neworder.hiddenClass);
    $(sortlistitem).find('.ph-' + orderselectoption).remove();
    $('.ph-neworder-menu ul li:first-child').append(checkmarkspan);
    $(document).on('DOMNodeInserted', ACC.neworder.advSearchNotificationClass, function() {
      $(ACC.neworder.advSearchNotificationClass).addClass('hidden');
    });
  }

  $(document).on('click', '.ph-advsearch-button', function() {
    executeAdvSearchByDefault();
  });
  $(document).on('click', '.ph-orderhistory-search, .ph-advancedSearchNotification', function(event) {
    event.preventDefault();
    ACC.neworder.showAdvanceSearchBlock();
    executeAdvSearchByDefault();
  });

  $(document).ready(function() {
    var currentLink = window.location.href;

    if (currentLink.endsWith(ACC.neworder.advSearchAnchor)) {
      ACC.neworder.showAdvanceSearchBlock();
    }

    if ($('#ph-isLocalOrderCreateEnable').val() === 'true' && $('#ph-notificationAdvancedSearch').length > 0) {
      $('.ph-eachMonthBlock:first').prepend('<div class="ph-neworderresult ph-advancedSearchNotification">' +
      $('#ph-notificationAdvancedSearch').html() + '</div>');
    }

    if ($('.pageLabel-myDashboardPage').length > 0) {
      $('.ph-achorchange').attr('href', '../orderhistory#advancedOrdersSearch');
    }
  });
  $(window).on('load', function() {
    var currentLink = window.location.href;

    if (currentLink.endsWith(ACC.neworder.advSearchAnchor)) {
      executeAdvSearchByDefault();
    }
  });
  $(document).on('change', productCodeType, function() {
    if ($(this).val() === '12NC') {
      $('.' + ACC.neworder.label12NC).removeClass(ACC.neworder.hiddenClass);
      $('.' + ACC.neworder.labelCtv).addClass(ACC.neworder.hiddenClass);
      $('.' + ACC.neworder.labelEan).addClass(ACC.neworder.hiddenClass);
    } else if ($(this).val() === 'EAN') {
      $('.' + ACC.neworder.labelEan).removeClass(ACC.neworder.hiddenClass);
      $('.' + ACC.neworder.labelCtv).addClass(ACC.neworder.hiddenClass);
      $('.' + ACC.neworder.label12NC).addClass(ACC.neworder.hiddenClass);
    } else {
      $('.' + ACC.neworder.labelCtv).removeClass(ACC.neworder.hiddenClass);
      $('.' + ACC.neworder.labelEan).addClass(ACC.neworder.hiddenClass);
      $('.' + ACC.neworder.label12NC).addClass(ACC.neworder.hiddenClass);
    }
  });
  $(document).on('click', '.ph-ordersort__optionicon', function() {
    $('.ph-orderfilter-menutooltip').addClass(ACC.neworder.hiddenClass);
    $(ordersortmenu).toggleClass(ACC.neworder.hiddenClass);
  });
  $(document).on('click', '.ph-orderfilter__optionicon', function() {
    $(ordersortmenu).addClass(ACC.neworder.hiddenClass);
    $('.ph-orderfilter-menutooltip').toggleClass(ACC.neworder.hiddenClass);
  });
});
$(document).ready(function() {
  var returncustomerid = '#cboxContent #productCode',
      formerrormsg = 'ph-formerrormsg',
      returnordersubmitbutton = '.ph-returnordersubmitbutton',
      selreturnqtyid = '[id^=returnqty]',
      returnerrormsg = '.ph-returnerrormsg',
      customeriderrormsg = '.ph-customeriderrormsg',
      selectreasoncode = 'select[name=reasonCode]',
      disablebtn = ACC.neworder.disabledBtnCls,
      qtyplusbutton = '.ph-order_qtyplus',
      qtyminusbutton = '.ph-order_qtyminus';

  $(document).on('click', '.ph-neworderreturn', function() {
    var orderCodeHistory = $(this).attr('data-ordernumber'),
        urlHistory = ACC.config.encodedContextPath + '/returnOrder/popup/' + orderCodeHistory;

    ACC.neworder.uploadedAttachement = [];
    $.ajax({
      url: urlHistory,
      data: {
        orderCode: orderCodeHistory
      },
      type: 'GET',
      datatype: 'html',
      success: function(resultHistory) {
        if (resultHistory.indexOf(ACC.neworder.sessionTimeoutIdentifier) !== -1) {
          window.location.reload();
        } else {
          setTimeout(function() {
            $.colorbox({
              html: resultHistory,
              maxWidth: '601',
              width: '90%',
              height: 'auto',
              overlayClose: true,
              onClosed: function() {
                ACC.neworder.fileListArray = [];
                ACC.neworder.uploadedAttachement = [];
              }
            });
            $.colorbox.resize();
          }, 201);
        }
      },
      error: function() {
        window.location.reload();
      }
    });
  });
  $(document).on('click', '.ph-orderreturncancel, .ph-returnorder__no, .ph-reorderclose', function() {
    ACC.neworder.fileListArray = [];
    ACC.neworder.uploadedAttachement = [];
    $.colorbox.close();
  });
  /* eslint-disable radix */
  $(document).on('change', '.ph-return-qtybox', function() {
    var maxQuantityOrder = $(this).attr('max'),
        minQuantityOrder = $(this).attr('min'),
        isCommentValid = 0,
        totalqty = 0;

    if (parseInt($(this).val()) >= parseInt(maxQuantityOrder)) {
      $(this).siblings(qtyplusbutton).addClass(disablebtn);
      $(this).val(maxQuantityOrder);
    } else {
      $(this).siblings(qtyplusbutton).removeClass(disablebtn);
    }

    if (parseInt($(this).val()) > parseInt(minQuantityOrder)) {
      $(this).siblings(qtyminusbutton).removeClass(disablebtn);
    } else {
      $(this).siblings(qtyminusbutton).addClass(disablebtn);
    }

    totalqty = ACC.neworder.checkForQunatityAdded(selreturnqtyid);
    isCommentValid = ACC.neworder.checkForAttachmentComment();

    if (isCommentValid > 0 && totalqty > 0 && $(returncustomerid).val() !== '' && $(selectreasoncode).val() !== 'default') {
      $(returnordersubmitbutton).removeClass(disablebtn);
    } else {
      $(returnordersubmitbutton).addClass(disablebtn);
    }
  });
  $(document).on('change', '.ph-returnorderValidation', function() {
    var totalqty = 0,
        isCommentValid = 0;

    if ($(returncustomerid).val() === '') {
      $(customeriderrormsg).show();
      $(returncustomerid).parent().addClass(formerrormsg);
      $.colorbox.resize();
    } else {
      $(customeriderrormsg).hide();
      $(returncustomerid).parent().removeClass(formerrormsg);
      $.colorbox.resize();
    }

    if ($(selectreasoncode).val() === 'default') {
      $(returnerrormsg).show();
      $(selectreasoncode).parent().addClass(formerrormsg);
      $.colorbox.resize();
    } else {
      $(returnerrormsg).hide();
      $(selectreasoncode).parent().removeClass(formerrormsg);
      $.colorbox.resize();
    }

    totalqty = ACC.neworder.checkForQunatityAdded(selreturnqtyid);
    isCommentValid = ACC.neworder.checkForAttachmentComment();

    if (isCommentValid > 0 && totalqty > 0 && $(ACC.neworder.formErrorCls).length === 0) {
      $(returnordersubmitbutton).removeClass(disablebtn);
    } else {
      $(returnordersubmitbutton).addClass(disablebtn);
    }
  });
  $(document).on('click', '.ph-list_plusminus', function() {
    var qtyminus = $(this).siblings(selreturnqtyid).val(),
        maxqty = parseInt($(this).siblings(selreturnqtyid).attr('max')),
        minqty = parseInt($(this).siblings(selreturnqtyid).attr('min')),
        isCommentValid = 0,
        isFormValid = 0,
        totalqty = 0;

    if ($(this).hasClass('ph-order_qtyminus')) {
      if (parseInt(qtyminus) !== 0) {
        $(this).siblings(selreturnqtyid).val(parseInt(qtyminus) - 1);
      }

      $(this).siblings(qtyplusbutton).removeClass(disablebtn);

      if (parseInt(qtyminus) - 1 === minqty) {
        $(this).addClass(disablebtn);
      } else {
        $(this).removeClass(disablebtn);
      }
    } else if ($(this).hasClass('ph-order_qtyplus')) {
      if (parseInt(qtyminus) <= maxqty) {
        $(this).siblings(selreturnqtyid).val(parseInt(qtyminus) + 1);
      }

      $(this).siblings(qtyminusbutton).removeClass(disablebtn);

      if (parseInt(qtyminus) + 1 === maxqty) {
        $(this).addClass(disablebtn);
      } else {
        $(this).removeClass(disablebtn);
      }
    }

    totalqty = ACC.neworder.checkForQunatityAdded(selreturnqtyid);
    isCommentValid = ACC.neworder.checkForAttachmentComment();
    isFormValid = ACC.neworder.checkForFormErrors(returncustomerid, selectreasoncode);

    if (isCommentValid > 0 && totalqty > 0 && isFormValid > 0) {
      $(returnordersubmitbutton).removeClass(disablebtn);
    } else {
      $(returnordersubmitbutton).addClass(disablebtn);
    }
  });
  $(document).on('blur', '#ph-addreturncomments', function() {
    var totalqty = 0,
        isFormValid = 0,
        isCommentValid = 0;

    totalqty = ACC.neworder.checkForQunatityAdded(selreturnqtyid);
    isCommentValid = ACC.neworder.checkForAttachmentComment();
    isFormValid = ACC.neworder.checkForFormErrors(returncustomerid, selectreasoncode);

    if (isCommentValid > 0 && totalqty > 0 && isFormValid > 0) {
      $(returnordersubmitbutton).removeClass(disablebtn);
    } else {
      $(returnordersubmitbutton).addClass(disablebtn);
    }
  });
  /* eslint-enable radix */

  $(document).on('click', returnordersubmitbutton, function(event) {
    var customerId = $('#cboxContent #productCode').val(),
        returnReason = $('select[name=reasonCode]').val(),
        $customerIdError = $('.ph-customeriderrormsg'),
        ordernum = $(this).attr('data-order'),
        form = $('#ph-returnordersubmit')[0],
        data = new FormData(form),
        $loaderForReturnBtn = $('.ph-returnordersubmitbutton .ph-interstitial-loader'),
        ind = 0,
        len = ACC.neworder.uploadedAttachement.length,
        urlConfirm = ACC.config.encodedContextPath + '/returnOrder/confirmation';

    event.preventDefault();

    for (ind; ind < len; ind = ind + 1) {
      data.append('attachments', ACC.neworder.uploadedAttachement[ind].file);
    }

    if (customerId === '' && returnReason === 'default') {
      $customerIdError.show();
      $(returnerrormsg).show();
      $.colorbox.resize();
    } else if (customerId === '') {
      $customerIdError.show();
      $.colorbox.resize();
    } else if (returnReason === 'default') {
      $(returnerrormsg).show();
      $.colorbox.resize();
    } else {
      $loaderForReturnBtn.removeClass('hidden');
      $.ajax({
        url: urlConfirm,
        data: data,
        type: 'POST',
        contentType: false,
        cache: false,
        processData: false,
        datatype: 'json',
        success: function(resultConfirm) {
          if (resultConfirm.success && resultConfirm.success.length > 0) {
            $.colorbox.close();
            $('.ph-returnmsg').text(resultConfirm.success);
            $('#ph-returnconfirmationmsg').removeClass(ACC.neworder.hiddenClass);
            $(window).scrollTop(0);
            $('.ph-ordernum_' + ordernum).addClass(disablebtn);
            $('#ph-detailbar' + ordernum).removeClass('ph-icon-arrow-up').addClass('ph-icon-arrow-down');
            $('#orderPanel' + ordernum).hide();
            $('#ph-detailbar' + ordernum).parent().removeClass('ph-panel-active');
            ACC.neworder.fileListObject = [];
          } else if (resultConfirm.attachments && resultConfirm.attachments.length > 0) {
            $(ACC.neworder.attachmentErrorMsg).html('');
            $.each(resultConfirm.attachments, function(item) {
              var attachment = '<div class="ph-file-error' + item + ' ">' + resultConfirm.attachments[item] + '</div>';

              $(ACC.neworder.attachmentErrorMsg).append(attachment).show();

              ACC.neworder.validateAttachment();
            });
          }

          $loaderForReturnBtn.addClass('hidden');
        }
      });
    }
  });
  $(document).on('keyup', '.ph-return-qtybox', function() {
    var quantity = Number($(this).val());

    if (!quantity) {
      quantity = 0;
      $(this).val(quantity);
    } else {
      $(this).val(quantity);
    }
  });
  $(document).on('change', '.ph-return-file', function(event) {
    var input = event.target,
        removeText = $('.ph-remove-text').val(),
        totalqty = 0,
        isFormValid = 0,
        templateHtmlHistory = '',
        fileSize = '',
        arrayIndexHistory = ACC.neworder.uploadedAttachement.length;

    if (input.files.length > 0) {
      $.each(input.files, function(index, uploadedFilesHistory) {
        var fileObject = {
          name: ''
        };

        fileSize = ACC.neworder.validateFileSize(uploadedFilesHistory);

        if (ACC.neworder.uploadedAttachement.length < 20 && fileSize === 'true') {
          ACC.neworder.uploadedAttachement.push({
            id: 'fileId' + arrayIndexHistory,
            file: uploadedFilesHistory
          });
          arrayIndexHistory = arrayIndexHistory + 1;
          fileObject.name = uploadedFilesHistory.name;
          ACC.neworder.fileListObject.push(uploadedFilesHistory);
          ACC.neworder.fileListArray.push(fileObject);
        }
      });

      $.each(ACC.neworder.fileListArray, function(indexer, uploadedFilesHistory) {
        templateHtmlHistory = templateHtmlHistory + (
          '<div class="ph-col-12 ph-d-flex ph-col-12 ph-align-items-center ph-file-rows ph-file-row' + indexer + ' ">' +
          '<div class="ph-col-8 ph-filesec ph-float-left">' +
          '<span class="ph-fileicon ph-float-left"></span>' +
          '<span class="ph-filename">' + uploadedFilesHistory.name + '</span></div>' +
          '<div class="ph-col-4 ph-p-0 ph-float-left ph-remove-file">' +
          '<span class="ph-remove-link" data-index=' + indexer + '>' + removeText + '</span></div>' +
          '</div>'
        );
      });

      $('#' + ACC.neworder.uploadFileNameId).html(templateHtmlHistory);

      if ($('.ph-file-rows').length > 0) {
        $('#' + ACC.neworder.uploadFileNameId).show();
        $('.ph-return-commentsec').show();
      }

      ACC.neworder.showFileMaxSizeError();
      $(ACC.neworder.commentInputId).focus();

      totalqty = ACC.neworder.checkForQunatityAdded(selreturnqtyid);
      isFormValid = ACC.neworder.checkForFormErrors(returncustomerid, selectreasoncode);

      if (totalqty > 0 && isFormValid > 0) {
        $(ACC.neworder.returnSubmitBtn).removeClass(ACC.neworder.disabledBtnCls);
      } else {
        $(ACC.neworder.returnSubmitBtn).addClass(ACC.neworder.disabledBtnCls);
      }

      $.colorbox.resize();
    }
  });
  $(document).on('click', '.ph-remove-link', function() {
    var indexer = $(this).attr('data-index'),
        isCommentValid = 0,
        isFormValid = 0,
        totalqty = 0,
        rowsLength = 0,
        ind = 0,
        itemer = $('.ph-remove-link').attr('data-index');

    $(ACC.neworder.attachmentFileRow + indexer).remove();
    $('.ph-file-error' + itemer).hide();
    ACC.neworder.fileListArray.splice(indexer, 1);

    rowsLength = $('.ph-file-rows').length;

    if (rowsLength === 0) {
      $('.ph-return-commentsec').hide();
      $('#' + ACC.neworder.uploadFileNameId).hide();
      $(ACC.neworder.attachmentErrorMsg).hide();
      ACC.neworder.fileListArray = [];
      ACC.neworder.uploadedAttachement = [];
    } else {
      for (ind; ind < ACC.neworder.uploadedAttachement.length; ind = ind + 1) {
        if (ACC.neworder.uploadedAttachement[ind].id === 'fileId' + indexer) {
          ACC.neworder.uploadedAttachement.splice(ind, 1);
        }
      }
    }

    totalqty = ACC.neworder.checkForQunatityAdded(selreturnqtyid);
    isCommentValid = ACC.neworder.checkForAttachmentComment();
    isFormValid = ACC.neworder.checkForFormErrors(returncustomerid, selectreasoncode);

    if (isCommentValid > 0 && totalqty > 0 && isFormValid > 0) {
      $(returnordersubmitbutton).removeClass(disablebtn);
    } else {
      $(returnordersubmitbutton).addClass(disablebtn);
    }

    $('#file-upload').val('');
    $.colorbox.resize();
  });

  $(document).on('click', '.ph-problemwithorder_button', function() {
    var orderId = $(this).attr('data-order'),
        urlLink = window.location.href,
        trigger = 'linkCategory.clickHelpWithOrder',
        compname = 'linkHelpWithOrder',
        desc = 'Help With Order ' + orderId,
        userEventObj = '';

    $.colorbox({
      maxWidth: '600',
      width: '90%',
      height: 'auto',
      scrolling: true,
      html: $('.ph-problem_order-' + orderId).html(),
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
    userEventObj = ACC.googleanalytics.createUserEventForGa(urlLink, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });

  $(document).on('click', '.ph-errororder_cancel', function() {
    $.colorbox.close();
  });
});
/* eslint-enable max-statements*/
/* eslint-enable xss/no-mixed-html */
/* eslint-enable max-lines */
/* eslint-enable no-negated-condition*/
/* eslint-enable complexity*/
/* eslint-enable id-length*/
